import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GlassSpinner from "../../components/GlassSpinner";
import { useEmpresa } from "../../context/EmpresaContext";
import { useToast, ToastPopup } from "../../components/Toast";
import {
  getEventos, crearEvento, editarEvento, eliminarEvento, getRRPP,
  getEmpresaConfig, guardarMercadoPago, uploadEventGuestLogo,
  guardarEmailEmpresa, waitlistList, waitlistApprove, waitlistReject, waitlistUpdate, registerEntradas,
} from "../../services/sininApi";

export default function ClienteEventos() {
  const navigate          = useNavigate();
  const { empresa, setEmpresa, logout, colores } = useEmpresa();
  const GOLD              = colores.primario;
  const FUENTE            = colores.fuente;

  const [eventos, setEventos]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editEvento, setEditEvento] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [rrppList, setRrppList] = useState([]);
  const [rrppPopup, setRrppPopup] = useState(null);
  const { toast, showToast, closeToast } = useToast();
  const [showMp, setShowMp] = useState(false);
  const [savingMp, setSavingMp] = useState(false);
  const [showMailConfig, setShowMailConfig] = useState(false);
  const [savingMailConfig, setSavingMailConfig] = useState(false);
  const [uploadingInvitan, setUploadingInvitan] = useState("");
  const [mpConfig, setMpConfig] = useState({
    mpEnabled: false, mpPublicKey: "", mpAccessToken: "",
    mpWebhookSecret: "", mpMode: "test", mpFeePercent: "0",
  });
  const [mailConfig, setMailConfig] = useState({
    mailEnabled: false, smtpUser: "", smtpPass: "",
    mailAsunto: "Tus entradas", mailCuerpo: "Presentá tu entrada con DNI en el ingreso.",
  });

  const [waitlistEvento, setWaitlistEvento] = useState(null);
  const [waitlistItems, setWaitlistItems]   = useState([]);
  const [loadingWaitlist, setLoadingWaitlist] = useState(false);
  const [approvingId, setApprovingId]       = useState(null);
  const [editingEntry, setEditingEntry]     = useState(null); // entry abierto en drawer
  const [editForm, setEditForm]             = useState({});
  const [savingEdit, setSavingEdit]         = useState(false);
  const [wlFilters, setWlFilters]           = useState({ nombre: "", dni: "", sexo: "", email: "", instagram: "", ws: "" });
  const [wlSort, setWlSort]                 = useState({ col: null, dir: "asc" });

  const today    = new Date().toISOString().split("T")[0];
  const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

  const nextDay = (fecha) => {
    if (!fecha) return "";
    const d = new Date(normalizeDateInput(fecha) + "T12:00:00");
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  };

  const normalizeDateInput = (fecha) => {
    const value = String(fecha || "").trim();
    if (!value) return "";
    const normalized = value.replace(/\//g, "-");
    const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (!match) return normalized;
    const [, year, month, day] = match;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const FORM_EMPTY = {
    nombre: "", fecha: today, horaInicio: "22:00", fechaFin: tomorrow, horaFin: "01:00", capacidad: "",
    consumicion: false, consumicionTexto: "INCLUYE UNA CONSUMICIÓN", mostrarHoraFin: true, campos: [], logosInvitan: [],
    ventaOnline: false, mercadoPago: false, maxPorCompra: "6", ventaDesde: "", ventaHasta: "", mailEnabled: false,
    avisoArriba: { texto: "Válido hasta las 2 am", activo: true },
    avisoAbajo:  { texto: "Se suspende por lluvia", activo: true },
    tandas: [{ id: "1", label: "", precio: "", stock: "", tipo: "PAGO" }],
  };

  const [form, setForm] = useState(FORM_EMPTY);

  useEffect(() => {
    if (empresa?.empresaId) cargar();
    else setLoading(false); // eslint-disable-next-line
  }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const data = await getEventos(empresa.empresaId, empresa.loginType || "0");
      setEventos(Array.isArray(data) ? data : []);
    } catch {}
    try {
      const res = await getRRPP(empresa.empresaId);
      setRrppList(Array.isArray(res?.items) ? res.items : []);
    } catch {}
    try {
      const res = await getEmpresaConfig(empresa.empresaId);
      const cfg = res?.empresa || {};
      if (cfg.logoUrl || cfg.logoKey || cfg.nombre) {
        setEmpresa({
          ...empresa,
          nombre: cfg.nombre || empresa.nombre,
          logoKey: cfg.logoKey || empresa.logoKey,
          logoUrl: cfg.logoUrl || empresa.logoUrl,
          colorTicket: cfg.colorTicket || empresa.colorTicket,
          colorFondo: cfg.colorFondo || empresa.colorFondo,
          colorFuente: cfg.colorFuente || empresa.colorFuente,
          colorDark: cfg.colorDark || empresa.colorDark,
          colorLight: cfg.colorLight || empresa.colorLight,
        });
      }
      setMpConfig({
        mpEnabled: !!cfg.mpEnabled,
        mpPublicKey: cfg.mpPublicKey || "",
        mpAccessToken: cfg.mpAccessToken || "",
        mpWebhookSecret: cfg.mpWebhookSecret || "",
        mpMode: cfg.mpMode || "test",
        mpFeePercent: cfg.mpFeePercent || "0",
      });
      setMailConfig({
        mailEnabled: cfg.mailEnabled === true,
        smtpUser: cfg.smtpUser || cfg.smtpUserBackup || "",
        smtpPass: "",
        mailAsunto: cfg.mailAsunto || "Tus entradas",
        mailCuerpo: cfg.mailCuerpo || "Presentá tu entrada con DNI en el ingreso.",
      });
    } catch {}
    setLoading(false);
  };

  const rrppDeEvento = (idEvento) => rrppList.filter(v => Array.isArray(v.eventos) && v.eventos.includes(idEvento));

  const setF = k => e => {
    const val = e.target.value;
    setForm(p => {
      const next = { ...p, [k]: val };
      if (k === "fecha") next.fechaFin = nextDay(val);
      return next;
    });
  };

  const addCampo = () => setForm(p => ({
    ...p,
    campos: [...p.campos, { id: String(Date.now()), label: "", tipo: "sinNo", opciones: "" }],
  }));
  const setCampo = (i, k, v) => setForm(p => {
    const c = [...p.campos]; c[i] = { ...c[i], [k]: v }; return { ...p, campos: c };
  });
  const removeCampo = i => setForm(p => ({ ...p, campos: p.campos.filter((_, idx) => idx !== i) }));

  const setAvisoField = (slot, k, v) => setForm(p => ({ ...p, [slot]: { ...p[slot], [k]: v } }));
  const setTanda = (i, k, v) => setForm(p => {
    const t = [...p.tandas];
    t[i] = { ...t[i], [k]: v };
    return { ...p, tandas: t };
  });
  const addTanda = () => setForm(p => ({
    ...p,
    tandas: [...p.tandas, { id: String(p.tandas.length + 1), label: "", precio: "0", stock: "", tipo: "PAGO" }],
  }));
  const removeTanda = i => setForm(p => ({ ...p, tandas: p.tandas.filter((_, idx) => idx !== i) }));

  const handleInvitanLogo = async (file, slot) => {
    if (!file) return;
    const eventId = editEvento?.idEvento || `${form.fecha || "evento"}_${form.nombre || "nuevo"}`;
    setUploadingInvitan(String(slot));
    try {
      const fileB64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      const res = await uploadEventGuestLogo(empresa.empresaId, eventId, slot, fileB64, file.name);
      if (res?.error || !res?.logoKey) throw new Error(res?.error || "No se pudo subir el logo");
      setForm(previous => {
        const logos = [...(previous.logosInvitan || [])];
        logos[slot - 1] = { key: res.logoKey, url: res.url || "" };
        return { ...previous, logosInvitan: logos.filter(Boolean).slice(0, 2) };
      });
    } catch (e) {
      showToast(e.message || "No se pudo subir el logo invitado.", "error");
    } finally {
      setUploadingInvitan("");
    }
  };

  const abrirEditar = (ev) => {
    setEditEvento(ev);
    const fechaBase = normalizeDateInput(ev.fechaEvento || ev.fecha || today);
    const fechaFinBase = normalizeDateInput(ev.fechaFinEvento) || nextDay(fechaBase);
    setForm({
      nombre:      ev.name || ev.nombre || "",
      fecha:       fechaBase,
      horaInicio:  ev.horaInicioEvento || "22:00",
      fechaFin:    fechaFinBase,
      horaFin:     ev.horaFinEvento    || "01:00",
      mostrarHoraFin: ev.mostrarHoraFin !== false,
      capacidad:   ev.stock || "",
      consumicion: ev.consumicion || false,
      consumicionTexto: ev.consumicionTexto || "INCLUYE UNA CONSUMICIÓN",
      ventaOnline: !!ev.ventaOnline,
      mercadoPago: !!ev.mercadoPago,
      mailEnabled: !!ev.mailEnabled,
      maxPorCompra: String(ev.maxPorCompra || 6),
      ventaDesde: ev.ventaDesde || "",
      ventaHasta: ev.ventaHasta || "",
      campos:      (ev.campos || []).map(c => ({
        ...c,
        opciones: Array.isArray(c.opciones) ? c.opciones.join(", ") : (c.opciones || ""),
        activo: c.activo !== false,
      })),
      logosInvitan: (ev.logosInvitan || []).slice(0, 2).map((key, index) => ({
        key,
        url: (ev.logosInvitanUrls || [])[index] || "",
      })),
      avisoArriba: ev.avisoArriba?.texto
        ? ev.avisoArriba
        : { texto: "Válido hasta las 2 am", activo: true },
      avisoAbajo: ev.avisoAbajo?.texto
        ? ev.avisoAbajo
        : { texto: "Se suspende por lluvia", activo: true },
      tandas: (ev.tandas || []).map(t => ({
        id: t.id, label: t.label, tipo: t.tipo,
        precio: t.precio || "", stock: t.stock || "",
      })),
    });
    setShowForm(true);
  };

  const buildPayload = () => ({
    nombre:      form.nombre,
    fecha:       form.fecha,
    horaInicio:  form.horaInicio,
    fechaFin:    form.fechaFin,
    horaFin:     form.horaFin,
    mostrarHoraFin: form.mostrarHoraFin,
    capacidad:   parseInt(form.capacidad) || 0,
    consumicion: form.consumicion,
    consumicionTexto: form.consumicionTexto,
    ventaOnline: form.ventaOnline,
    mercadoPago: form.ventaOnline && form.mercadoPago,
    mailEnabled: form.mailEnabled,
    maxPorCompra: parseInt(form.maxPorCompra) || 6,
    ventaDesde: form.ventaDesde,
    ventaHasta: form.ventaHasta,
    campos:      form.campos.map(c => ({
      id:      c.id,
      label:   c.label,
      tipo:    c.tipo,
      activo:  c.activo !== false,
      opciones: c.tipo === "dropdown"
        ? (typeof c.opciones === "string" ? c.opciones.split(",").map(s => s.trim()).filter(Boolean) : c.opciones)
        : [],
    })),
    logosInvitan: (form.logosInvitan || []).map(item => item?.key).filter(Boolean).slice(0, 2),
    avisoArriba: form.avisoArriba,
    avisoAbajo:  form.avisoAbajo,
    tandas: form.tandas.map((t, i) => ({
      id:     t.id || String(i + 1),
      label:  t.label,
      tipo:   t.tipo,
      precio: t.tipo === "CORTESIA" ? 0 : parseInt(t.precio) || 0,
      stock:  parseInt(t.stock) || 0,
    })),
  });

  const handleGuardar = async () => {
    if (!form.nombre || !form.fecha) return showToast("Nombre y fecha requeridos.", "error");
    setSaving(true);
    try {
      if (editEvento) {
        await editarEvento(empresa.empresaId, { idEvento: editEvento.idEvento, ...buildPayload() });
      } else {
        await crearEvento(empresa.empresaId, buildPayload());
      }
      showToast(editEvento ? "Evento actualizado." : "Evento creado correctamente.", "success");
      setShowForm(false);
      setEditEvento(null);
      setForm(FORM_EMPTY);
      cargar();
    } catch (e) { showToast("Error al guardar evento: " + (e?.response?.data?.error || e?.message || ""), "error"); }
    setSaving(false);
  };

  const guardarConfigMp = async () => {
    if (mpConfig.mpEnabled && (!mpConfig.mpPublicKey || !mpConfig.mpAccessToken)) {
      return showToast("Para activar Mercado Pago completá Public Key y Access Token.", "error");
    }
    setSavingMp(true);
    try {
      const res = await guardarMercadoPago(empresa.empresaId, mpConfig);
      if (res?.error) throw new Error(res.error);
      showToast("Configuración de Mercado Pago guardada.", "success");
      setShowMp(false);
      await cargar();
    } catch (e) {
      showToast("No se pudo guardar Mercado Pago: " + (e?.message || "Intentá nuevamente."), "error");
    }
    setSavingMp(false);
  };

  const guardarConfigMail = async () => {
    if (mailConfig.mailEnabled && (!mailConfig.smtpUser || !mailConfig.smtpPass)) {
      return showToast("Para activar el envío completá Gmail y App Password.", "error");
    }
    setSavingMailConfig(true);
    try {
      const res = await guardarEmailEmpresa(empresa.empresaId, mailConfig);
      if (res?.error) throw new Error(res.error);
      showToast("Configuración de email guardada.", "success");
      setShowMailConfig(false);
      await cargar();
    } catch (e) {
      showToast("No se pudo guardar email: " + (e?.message || "Intentá nuevamente."), "error");
    }
    setSavingMailConfig(false);
  };

  const abrirWaitlist = async (ev) => {
    setWaitlistEvento(ev);
    setLoadingWaitlist(true);
    setWaitlistItems([]);
    try {
      const res = await waitlistList(empresa.empresaId, ev.idEvento);
      setWaitlistItems(Array.isArray(res?.items) ? res.items : []);
    } catch { showToast("Error cargando lista de espera.", "error"); }
    setLoadingWaitlist(false);
  };

  const handleApprove = async (entry) => {
    setApprovingId(entry.id);
    try {
      // 1. Emitir ticket
      const res = await registerEntradas([{
        empresaId:  empresa.empresaId.toUpperCase(),
        idEvento:   entry.eventoId,
        dni:        entry.dni,
        first_name: entry.first_name,
        last_name:  entry.last_name,
        email:      entry.email || "",
        quantity:   1,
        price:      "0",
        tipoPago:   "CORTESIA",
        createdBy:  "online",
        tanda:      "General online",
        tandaId:    "general-online",
        sexo:       entry.sexo || "",
        forceMail:  true,
      }]);
      if (res?.error) throw new Error(res.error);
      const resultados = Array.isArray(res?.resultados) ? res.resultados : [];
      const error = resultados.find(r => !r.ok);
      if (error) throw new Error(error.error || "No se pudo generar/enviar la entrada.");
      const enviado = resultados.some(r => r.sentByMail === true);
      if (!enviado) throw new Error("Se generó la entrada, pero no se pudo enviar por email. Revisá Gmail/SMTP de la empresa.");
      // 2. Marcar como aprobado en waitlist
      await waitlistApprove(empresa.empresaId, entry.id);
      setWaitlistItems(p => p.filter(i => i.id !== entry.id));
      showToast(`✅ ${entry.first_name} ${entry.last_name} aprobado, entrada enviada.`, "success");
    } catch (e) {
      showToast("Error al aprobar: " + (e?.response?.data?.error || e?.message || ""), "error");
    }
    setApprovingId(null);
  };

  const handleReject = async (entry) => {
    await waitlistReject(empresa.empresaId, entry.id);
    setWaitlistItems(p => p.filter(i => i.id !== entry.id));
  };

  const abrirEdicion = (entry) => {
    setEditingEntry(entry);
    setEditForm({ first_name: entry.first_name, last_name: entry.last_name,
      email: entry.email || "", instagram: entry.instagram || "", dni: entry.dni,
      ws: entry.ws || "", sexo: entry.sexo || "" });
  };

  const handleSaveEdit = async () => {
    setSavingEdit(true);
    try {
      await waitlistUpdate(empresa.empresaId, editingEntry.id, editForm);
      setWaitlistItems(p => p.map(i => i.id === editingEntry.id ? { ...i, ...editForm } : i));
      setEditingEntry(null);
      showToast("Datos actualizados.", "success");
    } catch { showToast("Error al guardar.", "error"); }
    setSavingEdit(false);
  };

  const styles = makeStyles(GOLD, FUENTE);

  return (
    <div style={styles.page}>
      <div style={{ ...styles.header, background: empresa?.colorFondo || "#1a1a1a", color: FUENTE }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {empresa?.logoUrl && <img src={empresa.logoUrl} alt="" style={{ width: 52, height: 52, objectFit: "contain" }} />}
          <div>
          <div style={{ fontWeight: "700", fontSize: 16 }}>{empresa?.nombre || empresa?.empresaId}</div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>Panel de eventos</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {empresa?._impersonating && (
            <button style={styles.outlineBtn} onClick={() => {
              const admin = JSON.parse(localStorage.getItem("sinin_admin_session") || "null");
              localStorage.removeItem("sinin_admin_session");
              if (admin) setEmpresa(admin);
              navigate("/admin");
            }}>← Volver a Admin</button>
          )}
          <button style={styles.outlineBtn} onClick={() => navigate("/cliente/vendedores")}>Vendedores</button>
          <button style={styles.outlineBtn} onClick={() => {
            const loginEmpresa = empresa?.empresaId ? `/${String(empresa.empresaId).toUpperCase()}/admin` : "/ADMIN";
            logout();
            navigate(loginEmpresa);
          }}>Salir</button>
        </div>
      </div>

      <div style={styles.content}>
        <div style={{ ...styles.card, marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <div>
              <div style={{ fontWeight: "800", fontSize: 15 }}>EMAIL / GMAIL</div>
              <div style={{ fontSize: 12, color: "#777", marginTop: 3 }}>
                {mailConfig.mailEnabled ? `Activo · ${mailConfig.smtpUser || "sin Gmail visible"}` : "Desactivado para esta empresa"}
              </div>
            </div>
            <button style={styles.goldBtn} onClick={() => setShowMailConfig(v => !v)}>
              {showMailConfig ? "Cerrar" : "Configurar"}
            </button>
          </div>

          {showMailConfig && (
            <div style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 12 }}>
              <label style={{ display: "flex", gap: 9, alignItems: "center", fontWeight: "700", fontSize: 14 }}>
                <input type="checkbox" checked={mailConfig.mailEnabled}
                  onChange={e => setMailConfig(p => ({ ...p, mailEnabled: e.target.checked }))}
                  style={{ width: 18, height: 18 }} />
                Activar envío de tickets por email
              </label>

              <label style={styles.label}>Gmail</label>
              <input style={styles.input} value={mailConfig.smtpUser}
                onChange={e => setMailConfig(p => ({ ...p, smtpUser: e.target.value }))}
                placeholder="tuempresa@gmail.com" />

              <label style={styles.label}>App Password de Gmail</label>
              <input style={styles.input} type="password" value={mailConfig.smtpPass}
                onChange={e => setMailConfig(p => ({ ...p, smtpPass: e.target.value }))}
                placeholder="xxxx xxxx xxxx xxxx" />
              <div style={{ fontSize: 11, color: "#777", lineHeight: 1.45, marginTop: -6, marginBottom: 10 }}>
                Usá una contraseña de aplicación de Gmail, no la contraseña normal de la cuenta.
              </div>

              <label style={styles.label}>Asunto del mail</label>
              <input style={styles.input} value={mailConfig.mailAsunto}
                onChange={e => setMailConfig(p => ({ ...p, mailAsunto: e.target.value }))}
                placeholder="Tus entradas" />

              <label style={styles.label}>Cuerpo del mail</label>
              <textarea style={{ ...styles.input, minHeight: 80, resize: "vertical" }} value={mailConfig.mailCuerpo}
                onChange={e => setMailConfig(p => ({ ...p, mailCuerpo: e.target.value }))}
                placeholder="Presentá tu entrada con DNI en el ingreso." />

              <button style={{ ...styles.goldBtn, width: "100%", marginTop: 14 }}
                onClick={guardarConfigMail} disabled={savingMailConfig}>
                {savingMailConfig ? "Guardando..." : "Guardar email"}
              </button>
            </div>
          )}
        </div>

        {mpConfig.mpEnabled && <div style={{ ...styles.card, marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <div>
              <div style={{ fontWeight: "800", fontSize: 15 }}>MERCADO PAGO</div>
              <div style={{ fontSize: 12, color: "#777", marginTop: 3 }}>
                {mpConfig.mpEnabled ? "Activo para esta empresa" : "Venta online todavía desactivada"}
              </div>
            </div>
            <button style={styles.goldBtn} onClick={() => setShowMp(v => !v)}>
              {showMp ? "Cerrar" : "Configurar"}
            </button>
          </div>

          {showMp && (
            <div style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 12 }}>
              <label style={styles.label}>Modo</label>
              <select style={styles.input} value={mpConfig.mpMode}
                onChange={e => setMpConfig(p => ({ ...p, mpMode: e.target.value }))}>
                <option value="test">Pruebas</option>
                <option value="production">Producción</option>
              </select>

              <label style={styles.label}>Public Key</label>
              <input style={styles.input} value={mpConfig.mpPublicKey}
                onChange={e => setMpConfig(p => ({ ...p, mpPublicKey: e.target.value }))}
                placeholder="APP_USR-..." />

              <label style={styles.label}>Access Token</label>
              <input style={styles.input} type="password" value={mpConfig.mpAccessToken}
                onChange={e => setMpConfig(p => ({ ...p, mpAccessToken: e.target.value }))}
                placeholder={mpConfig.mpAccessToken === "***" ? "Guardado - escribí solo para reemplazar" : "APP_USR-..."} />

              <label style={styles.label}>Webhook Secret</label>
              <input style={styles.input} type="password" value={mpConfig.mpWebhookSecret}
                onChange={e => setMpConfig(p => ({ ...p, mpWebhookSecret: e.target.value }))}
                placeholder={mpConfig.mpWebhookSecret === "***" ? "Guardado - escribí solo para reemplazar" : "Firma secreta del webhook"} />

              <label style={styles.label}>Recargo de servicio (%)</label>
              <input style={styles.input} type="number" min="0" step="0.1"
                value={mpConfig.mpFeePercent}
                onChange={e => setMpConfig(p => ({ ...p, mpFeePercent: e.target.value }))} />

              <div style={{ fontSize: 11, color: "#777", lineHeight: 1.45, marginTop: 10 }}>
                El Access Token y el secreto quedan en backend y nunca se muestran al comprador.
              </div>
              <button style={{ ...styles.goldBtn, width: "100%", marginTop: 14 }}
                onClick={guardarConfigMp} disabled={savingMp}>
                {savingMp ? "Guardando..." : "Guardar Mercado Pago"}
              </button>
            </div>
          )}
        </div>}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>Mis eventos</h2>
          <button style={styles.goldBtn} onClick={() => {
            if (showForm) { setShowForm(false); setEditEvento(null); setForm(FORM_EMPTY); }
            else setShowForm(true);
          }}>
            {showForm ? "Cancelar" : "+ Nuevo evento"}
          </button>
        </div>

        {showForm && (
          <div style={styles.card}>
            <h3 style={{ marginTop: 0, marginBottom: 16 }}>{editEvento ? `Editar: ${editEvento.name || editEvento.nombre}` : "Nuevo evento"}</h3>

            <label style={styles.label}>Nombre del evento *</label>
            <input style={styles.input} value={form.nombre} onChange={setF("nombre")} placeholder="Sunset Party..." />

            <label style={styles.label}>Fecha *</label>
            <input style={styles.input} type="date" value={form.fecha} min={editEvento ? undefined : today} onChange={setF("fecha")} />

            <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Hora inicio</label>
                <input style={styles.input} type="time" value={form.horaInicio} onChange={setF("horaInicio")} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Fecha fin</label>
                <input style={styles.input} type="date" value={form.fechaFin} min={editEvento ? undefined : (form.fecha || today)} onChange={setF("fechaFin")} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Hora fin</label>
                <input style={styles.input} type="time" value={form.horaFin} onChange={setF("horaFin")} />
              </div>
            </div>

            <label style={{ display: "flex", alignItems: "center", gap: 9, marginTop: 12, cursor: "pointer", fontSize: 13, fontWeight: "600" }}>
              <input type="checkbox" checked={form.mostrarHoraFin}
                onChange={e => setForm(p => ({ ...p, mostrarHoraFin: e.target.checked }))}
                style={{ width: 18, height: 18, cursor: "pointer" }} />
              Mostrar “HASTA {form.horaFin || "hora fin"}” en el ticket
            </label>

            <label style={styles.label}>Capacidad total</label>
            <input style={styles.input} type="number" value={form.capacidad} onChange={setF("capacidad")} placeholder="300" />

            <div style={{ marginTop: 18, padding: 14, border: "1px solid #ddd", borderRadius: 14, background: "#fafafa" }}>
              <div style={{ fontWeight: 900, fontSize: 13 }}>LOGOS “INVITAN” EN EL TICKET</div>
              <div style={{ fontSize: 11, color: "#777", marginTop: 4 }}>
                Podés agregar uno grande o dos logos. Se mostrarán debajo del QR.
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 10, marginTop: 12 }}>
                {[1, 2].map(slot => {
                  const logo = (form.logosInvitan || [])[slot - 1];
                  return (
                    <div key={slot} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 10, textAlign: "center", background: "#fff" }}>
                      {logo?.url ? (
                        <img src={logo.url} alt={`Invita ${slot}`} style={{ width: "100%", height: 65, objectFit: "contain", marginBottom: 8 }} />
                      ) : <div style={{ height: 65, display: "grid", placeItems: "center", color: "#aaa", fontSize: 11 }}>LOGO {slot}</div>}
                      <label style={{ ...styles.addTandaBtn, display: "inline-block", cursor: "pointer" }}>
                        <input type="file" accept="image/*" style={{ display: "none" }}
                          disabled={!!uploadingInvitan}
                          onChange={e => handleInvitanLogo(e.target.files?.[0], slot)} />
                        {uploadingInvitan === String(slot) ? "SUBIENDO..." : logo ? "CAMBIAR" : "AGREGAR"}
                      </label>
                      {logo && (
                        <button style={{ ...styles.removeBtn, marginLeft: 6 }}
                          onClick={() => setForm(previous => ({
                            ...previous,
                            logosInvitan: (previous.logosInvitan || []).filter((_, index) => index !== slot - 1),
                          }))}>✕</button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ marginTop: 18, padding: 14, border: "1px solid #ddd", borderRadius: 12, background: "#fafafa" }}>
              <label style={{ display: "flex", gap: 9, alignItems: "center", fontWeight: "700", fontSize: 14 }}>
                <input type="checkbox" checked={form.ventaOnline}
                  onChange={e => setForm(p => ({
                    ...p,
                    ventaOnline: e.target.checked,
                    mercadoPago: e.target.checked ? p.mercadoPago : false,
                  }))}
                  style={{ width: 18, height: 18 }} />
                Habilitar venta online para este evento
              </label>

              {form.ventaOnline && (
                <>
                  {mpConfig.mpEnabled && (
                    <label style={{ display: "flex", gap: 9, alignItems: "center", fontWeight: "600", fontSize: 13, marginTop: 12 }}>
                      <input type="checkbox" checked={form.mercadoPago}
                        onChange={e => setForm(p => ({ ...p, mercadoPago: e.target.checked }))}
                        style={{ width: 18, height: 18 }} />
                      Cobrar con Mercado Pago
                    </label>
                  )}
                  <label style={styles.label}>Máximo de tickets por compra</label>
                  <input style={styles.input} type="number" min="1" max="20"
                    value={form.maxPorCompra} onChange={setF("maxPorCompra")} />
                  <div style={{ display: "flex", gap: 10 }}>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>Venta desde</label>
                      <input style={styles.input} type="datetime-local"
                        value={form.ventaDesde} onChange={setF("ventaDesde")} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>Venta hasta</label>
                      <input style={styles.input} type="datetime-local"
                        value={form.ventaHasta} onChange={setF("ventaHasta")} />
                    </div>
                  </div>
                </>
              )}
            </div>

            <div style={{ marginTop: 14, padding: 14, border: "1px solid #ddd", borderRadius: 12, background: "#fafafa" }}>
              <label style={{ display: "flex", gap: 9, alignItems: "center", fontWeight: "700", fontSize: 14 }}>
                <input type="checkbox" checked={!!form.mailEnabled}
                  onChange={e => setForm(p => ({ ...p, mailEnabled: e.target.checked }))}
                  style={{ width: 18, height: 18 }} />
                Enviar entrada por email al generar ticket
              </label>
              <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>
                Requiere SMTP (Gmail) configurado en el panel de empresa.
              </div>
            </div>

            {/* Campos personalizados */}
            <div style={{ marginTop: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label style={{ ...styles.label, marginTop: 0 }}>Campos del formulario de inscripción</label>
                <button style={styles.addTandaBtn} onClick={addCampo}>+ Campo</button>
              </div>
              {form.campos.map((c, i) => (
                <div key={c.id} style={{ background: c.activo === false ? "#f8f8f8" : "#fff",
                  border: "1px solid #e0e0e0", borderRadius: 10, padding: "10px 12px", marginTop: 8, opacity: c.activo === false ? 0.6 : 1 }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                    <input style={{ ...styles.input, flex: 2, minWidth: 120 }} placeholder="Ej: ¿Viajás en combi?"
                      value={c.label} onChange={e => setCampo(i, "label", e.target.value)} />
                    <select style={{ ...styles.input, flex: 1, minWidth: 100 }} value={c.tipo}
                      onChange={e => setCampo(i, "tipo", e.target.value)}>
                      <option value="sinNo">Sí / No</option>
                      <option value="dropdown">Lista</option>
                      <option value="texto">Texto libre</option>
                    </select>
                    <button
                      title={c.activo === false ? "Activar campo" : "Desactivar campo"}
                      style={{ padding: "6px 10px", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 13,
                        background: c.activo === false ? "#e9ecef" : "#d1e7dd", color: c.activo === false ? "#555" : "#0a3622" }}
                      onClick={() => setCampo(i, "activo", c.activo === false ? true : false)}>
                      {c.activo === false ? "Inactivo" : "Activo"}
                    </button>
                    <button style={styles.removeBtn} onClick={() => removeCampo(i)}>✕</button>
                  </div>
                  {c.tipo === "dropdown" && (
                    <input style={{ ...styles.input, marginTop: 8 }}
                      placeholder="Opciones separadas por coma: Zona A, Zona B"
                      value={c.opciones} onChange={e => setCampo(i, "opciones", e.target.value)} />
                  )}
                </div>
              ))}
              {form.campos.length === 0 && (
                <div style={{ fontSize: 12, color: "#aaa", marginTop: 6 }}>
                  Sin campos extra — solo nombre, apellido, DNI y mail.
                </div>
              )}
            </div>

            {/* Avisos del ticket */}
            <label style={{ ...styles.label, marginTop: 20 }}>Avisos en el ticket</label>
            <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center",
              opacity: form.consumicion ? 1 : 0.55 }}>
              <input style={{ ...styles.input, flex: 1 }}
                value={form.consumicionTexto}
                disabled={!form.consumicion}
                placeholder="Ej: INCLUYE UNA CONSUMICIÓN DE STELLA"
                onChange={setF("consumicionTexto")} />
              <button
                style={{ padding: "6px 10px", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 12,
                  background: form.consumicion ? "#d1e7dd" : "#e9ecef",
                  color: form.consumicion ? "#0a3622" : "#555" }}
                onClick={() => setForm(p => ({ ...p, consumicion: !p.consumicion }))}>
                {form.consumicion ? "Activo" : "Inactivo"}
              </button>
            </div>
            {[
              ["avisoArriba", "Arriba (debajo del tipo de entrada) — ej: Válido hasta las 2 am"],
              ["avisoAbajo",  "Abajo (al pie del ticket) — ej: Se suspende por lluvia"],
            ].map(([slot, hint]) => (
              <div key={slot} style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center",
                opacity: form[slot].activo ? 1 : 0.55 }}>
                <input style={{ ...styles.input, flex: 1 }} placeholder={hint}
                  value={form[slot].texto}
                  onChange={e => setAvisoField(slot, "texto", e.target.value)} />
                <button
                  style={{ padding: "6px 10px", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 12, whiteSpace: "nowrap",
                    background: form[slot].activo ? "#d1e7dd" : "#e9ecef",
                    color: form[slot].activo ? "#0a3622" : "#555" }}
                  onClick={() => setAvisoField(slot, "activo", !form[slot].activo)}>
                  {form[slot].activo ? "Activo" : "Inactivo"}
                </button>
              </div>
            ))}

            <label style={{ ...styles.label, marginTop: 20 }}>Tandas / Tipos de entrada</label>
            {form.tandas.map((t, i) => (
              <div key={i} style={styles.tandaRow}>
                <input style={{ ...styles.input, flex: 2 }} placeholder="Ej: Early Bird"
                  value={t.label} onChange={e => setTanda(i, "label", e.target.value)} />
                <select style={{ ...styles.input, flex: 1 }} value={t.tipo}
                  onChange={e => setTanda(i, "tipo", e.target.value)}>
                  <option value="PAGO">Pago</option>
                  <option value="CORTESIA">Cortesía</option>
                </select>
                {t.tipo === "PAGO" && (
                  <input style={{ ...styles.input, flex: 1 }} type="number" placeholder="Precio"
                    value={t.precio} onChange={e => setTanda(i, "precio", e.target.value)} />
                )}
                <input style={{ ...styles.input, flex: 1 }} type="number" placeholder="Stock"
                  value={t.stock} onChange={e => setTanda(i, "stock", e.target.value)} />
                {form.tandas.length > 1 && (
                  <button style={styles.removeBtn} onClick={() => removeTanda(i)}>✕</button>
                )}
              </div>
            ))}
            <button style={styles.addTandaBtn} onClick={addTanda}>+ Agregar tanda</button>

            <button style={{ ...styles.goldBtn, width: "100%", marginTop: 20 }} onClick={handleGuardar} disabled={saving}>
              {saving ? "Guardando..." : editEvento ? "Guardar cambios" : "Crear evento"}
            </button>
          </div>
        )}

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
            <GlassSpinner size={70} background={empresa?.colorFondo || "#1a1a1a"} />
          </div>
        ) : eventos.length === 0 ? (
          <p style={{ textAlign: "center", color: "#888", padding: 40 }}>No tenés eventos todavía.</p>
        ) : (
          <div style={styles.eventosList}>
            {eventos.map(ev => (
              <div key={ev.idEvento} style={styles.eventoCard}>
                {ev.image1 && (
                  <img src={ev.image1} alt={ev.name} style={{ width: 70, height: 70, borderRadius: 10, objectFit: "cover" }} />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "700", fontSize: 16 }}>{ev.name || ev.nombre}</div>
                  <div style={{ color: "#888", fontSize: 13, marginTop: 2 }}>{ev.fechaEvento || ev.fecha}</div>
                  <div style={{ marginTop: 4, fontSize: 13, color: "#555" }}>
                    {ev.vendidas ?? 0} vendidas · {ev.disponibles ?? "∞"} disponibles
                  </div>
                  <div style={{ marginTop: 4, fontSize: 13, color: GOLD, cursor: "pointer", fontWeight: "600" }}
                    onClick={() => setRrppPopup(ev)}>
                    👤 {rrppDeEvento(ev.idEvento).length} RRPP asignado{rrppDeEvento(ev.idEvento).length === 1 ? "" : "s"}
                  </div>
                  <div style={{ marginTop: 6, display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {(ev.tandas || []).map(t => (
                      <span key={t.id} style={{ ...styles.tandaBadge, background: t.tipo === "CORTESIA" ? "#d1e7dd" : "#fff3cd" }}>
                        {t.label} {t.tipo === "PAGO" ? `$${t.precio}` : "Cortesía"}
                      </span>
                    ))}
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-end" }}>
                  <button style={styles.goldBtn} onClick={() => navigate(`/cliente/invitados/${ev.idEvento}`)}>
                    Entradas
                  </button>
                  <button style={styles.grayBtn} onClick={() => navigate(`/cliente/vendedores?evento=${ev.idEvento}`)}>
                    RRPP
                  </button>
                  <button style={styles.grayBtn} onClick={() => { abrirEditar(ev); window.scrollTo(0,0); }}>
                    Editar
                  </button>
                  <button style={styles.grayBtn} onClick={() => abrirWaitlist(ev)}>
                    ⏳ Espera
                  </button>
                  <button
                    title={(ev.vendidas ?? 0) > 0 ? "No se puede eliminar: hay tickets emitidos" : "Eliminar evento"}
                    style={{ ...styles.deleteBtn, opacity: (ev.vendidas ?? 0) > 0 ? 0.35 : 1,
                      cursor: (ev.vendidas ?? 0) > 0 ? "not-allowed" : "pointer" }}
                    onClick={async () => {
                      if ((ev.vendidas ?? 0) > 0) return;
                      if (!window.confirm(`¿Eliminar "${ev.name || ev.nombre}"? Esta acción no se puede deshacer.`)) return;
                      try {
                        await eliminarEvento(empresa.empresaId, ev.idEvento);
                        cargar();
                      } catch { showToast("Error al eliminar.", "error"); }
                    }}>
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Popup RRPP del evento ── */}
      {rrppPopup && (
        <div style={styles.overlay} onClick={() => setRrppPopup(null)}>
          <div style={styles.popupCard} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <h3 style={{ margin: 0, fontSize: 16 }}>RRPP — {rrppPopup.name || rrppPopup.nombre}</h3>
              <button onClick={() => setRrppPopup(null)}
                style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#aaa" }}>✕</button>
            </div>
            {rrppDeEvento(rrppPopup.idEvento).length === 0 ? (
              <p style={{ textAlign: "center", color: "#888", fontSize: 13, padding: 20 }}>
                Ningún RRPP asignado a este evento.
              </p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {rrppDeEvento(rrppPopup.idEvento).map(v => (
                  <div key={v.dni} style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "8px 10px", background: "#f4f4f4", borderRadius: 8, opacity: v.active === "1" ? 1 : 0.5 }}>
                    <div>
                      <div style={{ fontWeight: "600", fontSize: 14 }}>{v.first_name} {v.last_name}</div>
                      <div style={{ fontSize: 12, color: "#888" }}>DNI {v.dni}</div>
                    </div>
                    <span style={{ fontSize: 11, fontWeight: "700", color: v.active === "1" ? "#198754" : "#999" }}>
                      {v.active === "1" ? "Activo" : "Inactivo"}
                    </span>
                  </div>
                ))}
              </div>
            )}
            <button style={{ ...styles.goldBtn, width: "100%", marginTop: 16 }}
              onClick={() => { navigate(`/cliente/vendedores?evento=${rrppPopup.idEvento}`); setRrppPopup(null); }}>
              Gestionar RRPP de este evento
            </button>
          </div>
        </div>
      )}
      {/* ── Panel full-screen lista de espera ── */}
      {waitlistEvento && (
        <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "#f4f4f4", display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <div style={{ background: empresa?.colorFondo || "#1a1a1a", color: "#fff", padding: "14px 20px",
            display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
            <div>
              <div style={{ fontWeight: "800", fontSize: 16 }}>Lista de espera</div>
              <div style={{ fontSize: 12, opacity: 0.7 }}>{waitlistEvento.name || waitlistEvento.nombre}</div>
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              {/* Toggle activo/inactivo */}
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", userSelect: "none" }}>
                <div onClick={async () => {
                  const nuevoValor = waitlistEvento.waitlistActivo === "1" ? "0" : "1";
                  await editarEvento(empresa.empresaId, { idEvento: waitlistEvento.idEvento, waitlistActivo: nuevoValor });
                  setWaitlistEvento(p => ({ ...p, waitlistActivo: nuevoValor }));
                }} style={{
                  width: 40, height: 22, borderRadius: 11, cursor: "pointer",
                  background: waitlistEvento.waitlistActivo === "1" ? GOLD : "rgba(255,255,255,.2)",
                  position: "relative", transition: "background .2s", flexShrink: 0,
                }}>
                  <div style={{
                    position: "absolute", top: 3, left: waitlistEvento.waitlistActivo === "1" ? 21 : 3,
                    width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left .2s",
                  }} />
                </div>
                <span style={{ fontSize: 12, color: waitlistEvento.waitlistActivo === "1" ? GOLD : "rgba(255,255,255,.5)" }}>
                  {waitlistEvento.waitlistActivo === "1" ? "Activa" : "Inactiva"}
                </span>
              </label>
              {/* Fecha de expiración */}
              <input type="date" value={waitlistEvento.waitlistExpira || ""}
                onChange={async e => {
                  const val = e.target.value;
                  await editarEvento(empresa.empresaId, { idEvento: waitlistEvento.idEvento, waitlistExpira: val });
                  setWaitlistEvento(p => ({ ...p, waitlistExpira: val }));
                }}
                style={{ fontSize: 12, borderRadius: 8, border: "1px solid rgba(255,255,255,.3)",
                  background: "transparent", color: "#fff", padding: "5px 8px", cursor: "pointer" }} />
              <a href={`${window.location.origin}/espera/${empresa.empresaId}/${waitlistEvento.idEvento}`}
                target="_blank" rel="noreferrer"
                style={{ fontSize: 12, color: GOLD, fontWeight: "700", textDecoration: "none",
                  border: `1px solid ${GOLD}`, borderRadius: 20, padding: "6px 12px" }}>
                🔗 Link público
              </a>
              <button onClick={() => setWaitlistEvento(null)}
                style={{ background: "transparent", border: "1px solid rgba(255,255,255,.3)", color: "#fff",
                  borderRadius: 8, padding: "6px 14px", cursor: "pointer", fontSize: 13 }}>
                ← Volver
              </button>
            </div>
          </div>

          {/* Tabla */}
          <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
            {loadingWaitlist ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 60 }}>
                <GlassSpinner size={60} background="#f4f4f4" />
              </div>
            ) : waitlistItems.length === 0 ? (
              <div style={{ textAlign: "center", color: "#888", padding: 60, fontSize: 15 }}>
                No hay solicitudes pendientes para este evento.
              </div>
            ) : (() => {
              const COLS = [
                { key: "nombre",    label: "Nombre",    getValue: e => `${e.first_name} ${e.last_name}` },
                { key: "dni",       label: "DNI",       getValue: e => e.dni || "" },
                { key: "sexo",      label: "Sexo",      getValue: e => e.sexo || "" },
                { key: "email",     label: "Email",     getValue: e => e.email || "" },
                { key: "instagram", label: "Instagram", getValue: e => e.instagram || "" },
                { key: "ws",        label: "WhatsApp",  getValue: e => e.ws || "" },
              ];
              const toggleSort = (col) => setWlSort(s =>
                s.col === col ? { col, dir: s.dir === "asc" ? "desc" : "asc" } : { col, dir: "asc" }
              );
              const filtered = waitlistItems.filter(e => {
                const nombre = `${e.first_name} ${e.last_name}`.toLowerCase();
                return (
                  nombre.includes(wlFilters.nombre.toLowerCase()) &&
                  (e.dni || "").toLowerCase().includes(wlFilters.dni.toLowerCase()) &&
                  (e.sexo || "").toLowerCase().includes(wlFilters.sexo.toLowerCase()) &&
                  (e.email || "").toLowerCase().includes(wlFilters.email.toLowerCase()) &&
                  (e.instagram || "").toLowerCase().includes(wlFilters.instagram.toLowerCase()) &&
                  (e.ws || "").includes(wlFilters.ws)
                );
              });
              const sorted = wlSort.col
                ? [...filtered].sort((a, b) => {
                    const col = COLS.find(c => c.key === wlSort.col);
                    const va = col.getValue(a).toLowerCase();
                    const vb = col.getValue(b).toLowerCase();
                    return wlSort.dir === "asc" ? va.localeCompare(vb) : vb.localeCompare(va);
                  })
                : filtered;
              const GRID = "1.5fr 90px 80px 1.4fr 1fr 110px 140px";
              const cellBase = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
              const filterInput = (field) => (
                <input
                  value={wlFilters[field]}
                  onChange={e => setWlFilters(p => ({ ...p, [field]: e.target.value }))}
                  placeholder="Filtrar..."
                  onClick={e => e.stopPropagation()}
                  style={{ width: "100%", border: "1px solid #ddd", borderRadius: 5, padding: "4px 7px",
                    fontSize: 11, marginTop: 4, boxSizing: "border-box", outline: "none" }}
                />
              );
              return (
                <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,.08)", minWidth: 700 }}>
                  {/* Cabecera con sort + filtros */}
                  <div style={{ display: "grid", gridTemplateColumns: GRID,
                    background: "#f0f0f0", padding: "10px 16px", gap: 12 }}>
                    {COLS.map(({ key, label }) => (
                      <div key={key}>
                        <div onClick={() => toggleSort(key)}
                          style={{ fontSize: 11, fontWeight: "700", color: "#555", textTransform: "uppercase",
                            letterSpacing: 0.5, cursor: "pointer", userSelect: "none", display: "flex", gap: 4, alignItems: "center" }}>
                          {label}
                          <span style={{ fontSize: 10, color: wlSort.col === key ? GOLD : "#bbb" }}>
                            {wlSort.col === key ? (wlSort.dir === "asc" ? "▲" : "▼") : "⇅"}
                          </span>
                        </div>
                        {filterInput(key)}
                      </div>
                    ))}
                    <div style={{ fontSize: 11, fontWeight: "700", color: "#555", textTransform: "uppercase",
                      letterSpacing: 0.5, textAlign: "center", alignSelf: "start", paddingTop: 2 }}>
                      Acciones
                    </div>
                  </div>
                  {/* Filas */}
                  {sorted.length === 0 ? (
                    <div style={{ padding: 30, textAlign: "center", color: "#aaa", fontSize: 13 }}>
                      Sin resultados para este filtro.
                    </div>
                  ) : sorted.map((entry, i) => (
                    <div key={entry.id} style={{ display: "grid", gridTemplateColumns: GRID,
                      padding: "10px 16px", gap: 12, alignItems: "center",
                      background: i % 2 === 0 ? "#fff" : "#fafafa", borderBottom: "1px solid #f0f0f0" }}>
                      <span style={{ ...cellBase, fontWeight: "600", fontSize: 13 }}>
                        {entry.first_name} {entry.last_name}
                        <span style={{ display: "block", marginTop: 3, fontSize: 11, color: "#888", fontWeight: 500 }}>
                          Sexo: {entry.sexo || "—"} · WS: {entry.ws || "—"}
                        </span>
                      </span>
                      <span style={{ ...cellBase, fontSize: 13, color: "#555" }}>{entry.dni}</span>
                      <span style={{ ...cellBase, fontSize: 13, color: "#555" }}>{entry.sexo || "—"}</span>
                      <span style={{ ...cellBase, fontSize: 13, color: "#555" }}>{entry.email || "—"}</span>
                      <span style={cellBase}>
                        {entry.instagram
                          ? <a href={`https://instagram.com/${entry.instagram}`} target="_blank" rel="noreferrer"
                              style={{ fontSize: 13, color: GOLD, fontWeight: "600", textDecoration: "none" }}>
                              @{entry.instagram}
                            </a>
                          : <span style={{ color: "#ccc" }}>—</span>}
                      </span>
                      <span style={cellBase}>
                        {entry.ws
                          ? <a href={`https://wa.me/${entry.ws}`} target="_blank" rel="noreferrer"
                              style={{ fontSize: 13, color: "#25d366", fontWeight: "600", textDecoration: "none" }}>
                              {entry.ws}
                            </a>
                          : <span style={{ color: "#ccc" }}>—</span>}
                      </span>
                      <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                        <button onClick={() => abrirEdicion(entry)}
                          style={{ background: "none", border: "1px solid #ddd", borderRadius: 6,
                            padding: "5px 9px", cursor: "pointer", fontSize: 13 }}>✏️</button>
                        <button disabled={approvingId === entry.id} onClick={() => handleApprove(entry)}
                          style={{ background: GOLD, color: FUENTE, border: "none", borderRadius: 6,
                            padding: "5px 9px", cursor: "pointer", fontWeight: "700", fontSize: 12,
                            opacity: approvingId === entry.id ? 0.5 : 1 }}>
                          {approvingId === entry.id ? "..." : "✅"}
                        </button>
                        <button onClick={() => handleReject(entry)}
                          style={{ background: "#f8d7da", color: "#842029", border: "none",
                            borderRadius: 6, padding: "5px 9px", cursor: "pointer", fontWeight: "700", fontSize: 12 }}>
                          ✕
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        </div>
      )}

      {/* ── Drawer edición de entry de waitlist ── */}
      {editingEntry && (
        <div style={{ position: "fixed", inset: 0, zIndex: 10001, background: "rgba(0,0,0,.4)", display: "flex", justifyContent: "flex-end" }}
          onClick={() => setEditingEntry(null)}>
          <div style={{ width: "min(360px, 100vw)", background: "#fff", height: "100%",
            boxShadow: "-4px 0 24px rgba(0,0,0,.18)", display: "flex", flexDirection: "column",
            padding: 24, overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 16 }}>Editar solicitud</h3>
              <button onClick={() => setEditingEntry(null)}
                style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#aaa" }}>✕</button>
            </div>
            {[
              ["first_name", "Nombre"],
              ["last_name",  "Apellido"],
              ["dni",        "DNI"],
              ["email",      "Email"],
              ["instagram",  "Instagram (sin @)"],
              ["ws",         "WhatsApp (sin +)"],
              ["sexo",       "Sexo"],
            ].map(([key, label]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={styles.label}>{label}</label>
                <input style={styles.input} value={editForm[key] || ""}
                  onChange={e => setEditForm(p => ({ ...p, [key]: e.target.value }))} />
              </div>
            ))}
            <button onClick={handleSaveEdit} disabled={savingEdit}
              style={{ ...styles.goldBtn, width: "100%", marginTop: 8, opacity: savingEdit ? 0.65 : 1 }}>
              {savingEdit ? "Guardando..." : "Guardar cambios"}
            </button>
          </div>
        </div>
      )}

      <ToastPopup toast={toast} onClose={closeToast} accentColor={GOLD} accentText={FUENTE} />
    </div>
  );
}

const makeStyles = (GOLD, FUENTE) => ({
  page:       { background: "#f4f4f4", minHeight: "100vh" },
  header:     { background: "#1a1a1a", color: "#fff", padding: "14px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" },
  content:    { padding: 16, maxWidth: 700, margin: "0 auto" },
  card:       { background: "#fff", borderRadius: 14, padding: 20, marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
  label:      { display: "block", fontWeight: "600", fontSize: 13, marginTop: 12, marginBottom: 4, color: "#444" },
  input:      { padding: "10px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14, boxSizing: "border-box", width: "100%" },
  goldBtn:    { background: GOLD, color: FUENTE, border: "none", borderRadius: 25, padding: "9px 18px", cursor: "pointer", fontWeight: "700", fontSize: 13, whiteSpace: "nowrap" },
  grayBtn:    { background: "transparent", color: "#555", border: "1px solid #ccc", borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" },
  outlineBtn: { background: "transparent", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontSize: 13 },
  removeBtn:  { background: "#f8d7da", color: "#842029", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer" },
  deleteBtn:  { background: "#f8d7da", color: "#842029", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 15 },
  addTandaBtn:{ background: "transparent", border: "1.5px dashed #ccc", borderRadius: 8, padding: "8px 14px", cursor: "pointer", color: "#888", marginTop: 8, fontSize: 13 },
  tandaRow:   { display: "flex", gap: 8, alignItems: "center", marginTop: 8, flexWrap: "wrap" },
  eventosList:{ display: "flex", flexDirection: "column", gap: 12 },
  overlay:    { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 16 },
  popupCard:  { background: "#fff", borderRadius: 16, padding: 22, width: "100%", maxWidth: 380, maxHeight: "80vh", overflowY: "auto", boxShadow: "0 8px 28px rgba(0,0,0,0.3)" },
  eventoCard: { background: "#fff", borderRadius: 14, padding: 16, display: "flex", gap: 16, alignItems: "flex-start", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
  tandaBadge: { padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: "600" },
});
